// extracted by mini-css-extract-plugin
export default {"timeAgo":"TimeAgo_timeAgo__RJuvI"};